import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core'
import React, { memo } from 'react'

const useToolTipTextStyles = makeStyles((theme: Theme) => ({
    tooltipContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: pxToRem(10),
    },
    shortcutKeyContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: pxToRem(3),
    },
    shortcutKey: {
        borderRadius: '3px',
        color: 'inherit',
        fontWeight: 'bolder',
        border: '1px solid rgb(218,218,218)',
        backgroundColor: theme.palette.grey[200],
        padding: '1px 3px',
    },
}))

export const ToolTipText = memo(
    ({
        label,
        smallLabel,
        customStyles = {},
    }: {
        label?: string
        smallLabel?: string
        customStyles?: Partial<
            Record<
                'tooltipContainer' | 'shortcutKeyContainer' | 'shortcutKey',
                string
            >
        >
    }) => {
        const {
            tooltipContainer,
            shortcutKeyContainer,
            shortcutKey,
        } = useToolTipTextStyles()
        const keys = smallLabel?.split('+')

        return (
            <div className={customStyles.tooltipContainer || tooltipContainer}>
                {label && <>{label}</>}
                {keys && (
                    <div
                        className={
                            customStyles.shortcutKeyContainer ||
                            shortcutKeyContainer
                        }
                    >
                        {keys.map((key, idx) => {
                            return (
                                <>
                                    <kbd
                                        className={
                                            customStyles.shortcutKey ||
                                            shortcutKey
                                        }
                                    >
                                        {key}
                                    </kbd>
                                    {idx !== keys.length - 1 && '+'}
                                </>
                            )
                        })}
                    </div>
                )}
            </div>
        )
    }
)
